// Centraliza cards que não enchem a linha (tela larga com poucos itens), em vez de deixá-los
// encostados à esquerda. Vale para os cards de Depoimentos (DepoimentosCard2) e as fotos da
// Nossa Equipe (ManagerGrid). Pedido de um cliente só = gate por codsite: fora da lista o
// alinhamento continua o de sempre.
const CODSITES_CENTRALIZA_CARDS = new Set<number>([
    2636, // Almar Imóveis (Daniel, 16/09)
]);

export const centralizaCardsDoSite = (site: any): boolean =>
    CODSITES_CENTRALIZA_CARDS.has(Number(site?.id));
